import { useInVistaExperimentVariant } from '@99designs/experiments';
import { getBriefCreateURL } from '@99designs/i18n';

const IBPO_PRODUCT_KEY = 'otherdesignibpo';

export function useIbpoBriefCreateURL() {
    const inVariant = useInVistaExperimentVariant('ds_sdp_ibpo');
    return getBriefCreateURL(undefined, inVariant('test') ? IBPO_PRODUCT_KEY : undefined);
}
